<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.358" height="18" viewBox="0 0 20.358 18">
    <g transform="translate(-409.903 -537.525)">
      <g>
        <g>
          <path
            d="M429.44,551.857a.5.5,0,0,1-.159-.026l-11.423-3.849H410.4a.5.5,0,0,1-.5-.5v-8.47a.5.5,0,0,1,.932-.251,9.418,9.418,0,0,0,1.835,2.262c1.207,1.263,2.7,1.233,5.034-.065a.688.688,0,0,0,.417-.525c.091-.7-.8-1.736-1.122-2.046a.5.5,0,0,1,.619-.78c.384.246,9.419,6.057,11.365,8.073,2.114,2.192.98,5.688.932,5.835A.5.5,0,0,1,429.44,551.857ZM410.9,546.982h7.037a.516.516,0,0,1,.16.026l10.991,3.7c.2-.935.454-3.006-.827-4.336-1.33-1.377-6.4-4.784-9.231-6.652a2.078,2.078,0,0,1,.08.84,1.684,1.684,0,0,1-.922,1.268c-1.718.958-4.229,1.988-6.218-.091a9.9,9.9,0,0,1-1.069-1.127Z"
            fill="#777"
          />
        </g>
      </g>
      <rect
        width="2.979"
        height="1"
        transform="translate(417.272 552.383) rotate(-70.361)"
        fill="#777"
      />
      <rect
        width="2.979"
        height="1"
        transform="translate(419.552 553.092) rotate(-70.361)"
        fill="#777"
      />
      <rect
        width="2.979"
        height="1"
        transform="translate(421.832 553.786) rotate(-70.361)"
        fill="#777"
      />
      <rect
        width="2.979"
        height="1"
        transform="translate(424.112 554.495) rotate(-70.361)"
        fill="#777"
      />
      <rect
        width="2.979"
        height="1"
        transform="translate(426.391 555.189) rotate(-70.361)"
        fill="#777"
      />
    </g>
  </svg>
</template>
